export default "__VITE_ASSET__CMjZ4aK2__"